<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <MovementHeaderActions v-if="isMovementRoute" />
        <PaymentHeaderActions v-if="isPaymentsRoute" />
        <TransferHeaderActions v-if="isTransferRoute" />
        <DefaultServiceValuesHeaderActions v-if="isDefaultServiceValuesRoute" />
      </template>
    </h-header>
    <router-view ref="financialRouterView" />
  </div>
</template>

<script>
import MovementHeaderActions from '@/views/movement/fragments/MovementHeaderActions'
import PaymentHeaderActions from '@/components/payment/fragments/PaymentHeaderActions'
import TransferHeaderActions from '@/components/transfer/fragments/TransferHeaderActions'
import DefaultServiceValuesHeaderActions from '@/components/defaultServiceValues/fragments/DefaultServiceValuesHeaderActions'

export default {
  name: 'Financial',

  components: {
    MovementHeaderActions,
    PaymentHeaderActions,
    TransferHeaderActions,
    DefaultServiceValuesHeaderActions,
  },

  computed: {
    isMovementRoute() {
      return this.$route.path.includes('admin-movements')
    },

    isPaymentsRoute() {
      return this.$route.path.includes('payments')
    },

    isTransferRoute() {
      return this.$route.path.includes('transfers')
    },

    isDefaultServiceValuesRoute() {
      return this.$route.path.includes('default-service-values')
    },
  },
}
</script>
